import { useQuery } from '@apollo/client';
import { Tabs } from 'antd';
import { useState } from 'react';

import { ReportTap } from '../../components';
import { GET_REPORTS } from '../../Graphql/queries/getQueries';
import { ReportTapsTemplate } from '../../services';
import Template from '../../Template'


const Enquiry = () => {

    const [path, setPath] = useState("/Reports/Enquiry/Campaign")
    const { error, loading, data, refetch } = useQuery(GET_REPORTS, {
        variables: {
            path
        },
        fetchPolicy: 'network-only'
    })

    const enquiryReportData = data?.Report?.nodes.map((report) => ({
        value: report.value, name: report.name, percentage: report.percent, color: report.color,
    }))


    const tableMap = (e, i) => {
        return {
            key: i,
            name: e.name,
            total_enquiries: e.value,
            percentage: e.percentage + '%',
        }
    }

    const columnsMap = (e) => {
        return [{
            title: e,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Total enquiries',
            dataIndex: 'total_enquiries',
            key: 'total_enquiries',
            // render: (record) => (<Link to='/enquiry'>{record} </Link>)
        },
        {
            title: 'Percentage',
            dataIndex: 'percentage',
            key: 'percentage',
        }]
    }

    const enquiryTapTitels = ['Campaign', 'Status', 'Source', 'Location', 'Device', 'Days', 'Hours']
    const enkuiryTableData = enquiryReportData?.map(tableMap)
    const enkuiryColumns = enquiryTapTitels.map(columnsMap)

    const enquiryTaps = [
        {
            key: 1,
            title: 'Campaign',
            columns: enkuiryColumns[0],
            path: "/Reports/Enquiry/Campaign"

        },

        {
            key: 2,
            title: 'Status',
            columns: enkuiryColumns[1],
            path: "/Reports/Enquiry/Status"

        },
        {
            key: 3,
            title: 'Source',
            columns: enkuiryColumns[2],
            path: "/Reports/Enquiry/Source"

        },
        {
            key: 4,
            title: 'Location',
            columns: enkuiryColumns[3],
            path: "/Reports/Enquiry/Location"

        },
        {
            key: 5,
            title: 'Device',
            columns: enkuiryColumns[4],
            path: "/Reports/Enquiry/Device"

        },
        {
            key: 6,
            title: 'Days',
            columns: enkuiryColumns[5],
            path: "/Reports/Enquiry/Time/Days"

        },
        {
            key: 7,
            title: 'Hours',
            columns: enkuiryColumns[6],
            path: "/Reports/Enquiry/Time/Hours"

        },

    ]

    const onchangePath = (path) => {
        setPath(path)
    }
    const taps = enquiryTaps.map((tap, i) => (
        {
            key: tap.key,
            label: tap.title,
            children: <ReportTap total={data?.Report.total} chartData={enquiryReportData} loading={loading} tableData={enkuiryTableData} columns={tap.columns} path={tap.path} onPathChange={onchangePath} />
        }
    ))

    const titels = ['Campaign', 'Status', 'Source', 'Location', 'Device', 'Days', 'Hours']
    const transitionPaths = ["/Reports/Enquiry/Campaign", "/Reports/Enquiry/Status", "/Reports/Enquiry/Source", "/Reports/Enquiry/Location", "/Reports/Enquiry/Device", "/Reports/Enquiry/Time/Days", "/Reports/Enquiry/Time/Hours"]
    return (
        <Template
            headerTitle={['Reports', 'Enquiry']}
            hasFilters={true}
        >
            <ReportTapsTemplate enquiryPaths={transitionPaths} enquiryTapTitels={titels} />
            {/* <Tabs defaultChecked='0' items={taps} style={{ marginBottom: 70, minHeight: 500 }} /> */}
        </Template>
    )
}

export default Enquiry


